package com.kinoshazam.deeplink

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.kinoshazam.model.Route
import com.kinoshazam.screens.decide.consumeJoinUrlFromBrowser
import com.kinoshazam.utils.parseUrlSafe

@Composable
fun DeeplinkHandler(deepLink: String?, navigate: (Route) -> Unit) {
    LaunchedEffect(deepLink) {
        deepLink?.parseUrlSafe()?.let { url ->
            if (url.protocol.name == "kinosh" && url.host == "details") {
                url.parameters["id"]?.let { id ->
                    navigate(Route.Dialog.Details(id = id.toInt(), false))
                }
            }

            if (url.protocol.name == "kinosh" && url.host == "reset-password") {
                url.parameters["token"]?.let { token ->
                    navigate(Route.Dialog.ChangePassword(token = token))
                }
            }

            partyCodeFrom(url)?.let { code ->
                navigate(Route.Dialog.Decide(partyCode = code))
                consumeJoinUrlFromBrowser()
            }
        }
    }
}

private fun partyCodeFrom(url: io.ktor.http.Url): String? {
    url.parameters["join"]?.trim()?.uppercase()?.ifBlank { null }?.let { return it }
    val segments = url.pathSegments.filter { it.isNotBlank() }
    if (segments.size >= 2 && segments.first().equals("join", ignoreCase = true)) {
        return segments[1].trim().uppercase().ifBlank { null }
    }
    if (url.protocol.name == "kinosh" && url.host.equals("party", ignoreCase = true)) {
        return (url.parameters["code"] ?: segments.firstOrNull())
            ?.trim()
            ?.uppercase()
            ?.ifBlank { null }
    }
    return null
}
